import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_TICKETS = '/api/tickets';
const RESOURCE_TICKET_COMMENTS = '/api/ticket_comments';


export default {
    async getAssignedTickets(id, params){
        return await Api()
        .get(`/api/employees/${id}/assigned_tickets`, {params})
        .catch((err) => errorHandler(err, null));
    },
    async getTickets(params){
        return await Api()
        .get(RESOURCE_TICKETS,{params})
        .catch((err) => errorHandler(err, null));
    },
    async getRequestedTickets(id, params){
        return await Api()
            .get(`/api/employees/${id}/tickets_requested`, {params})
            .catch((err) => errorHandler(err, null));
    },
    async getTicket(id){
        return Api()
            .get(RESOURCE_TICKETS+'/'+id)
            .catch((err) => errorHandler(err, null));
    },
    async getTicketDocument(url){
        return Api()
            .get(url)
            .catch((err) => errorHandler(err, null));
    },
    // Comentarios del ticket que el usuario puede ver (los privados solo si gestiona el ticket)
    async getTicketComments(ticketId){
        return Api()
            .get(`${RESOURCE_TICKETS}/${ticketId}/comments`)
            .catch((err) => errorHandler(err, null));
    },
    async createComment(data){
        return await Api().post(RESOURCE_TICKET_COMMENTS, data)
            .catch(error => {
            console.log('Error: ' + error.response)
        })
    },
    async createTicket(data){
        return await Api().post(RESOURCE_TICKETS, data)
            .catch(error => {
                console.log('Error: ' + error.response)
            })
    },
    async updateTicket(data, id){
        return await Api().put(RESOURCE_TICKETS +'/'+id, data)
            .catch(error => {
                console.log('Error: ' + error.response)
            })
    },
    // Los adjuntos siempre van a un ticket ya creado (no hay subidas sueltas que puedan quedar huérfanas)
    async createMediaTicket(ticketId, file){
        const formData = new FormData();
        formData.append("file", file, file.name);
        return await Api().post(`/api/tickets/${ticketId}/documents`, formData);
    },
    // Sube los archivos elegidos al crear el ticket, una vez guardado. Devuelve los nombres que fallaron.
    async uploadTicketDocuments(ticketId, files){
        const failed = [];
        for (const file of files) {
            try {
                await this.createMediaTicket(ticketId, file);
            } catch (e) {
                failed.push(file.name);
            }
        }
        return failed;
    },
    // contentUrl apunta a la descarga autenticada (/api/ticket_document_media_objects/{id}/download):
    // el fichero ya no está en una ruta pública, así que hay que pedirlo con el token.
    async downloadTicketDocument(contentUrl){
        return await Api().get(process.env.VUE_APP_BASE_URI + contentUrl, { responseType: 'blob' });
    },
    async deleteMediaTicket(id){
       return await Api().delete(`/api/ticket_document_media_objects/${id}`);
    }
}
